import React from 'react';
import { Text } from '@fluentui/react-components';
import { Delete24Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { Button } from '../../Button';
import { ChatAvatar } from '../ChatAvatar/ChatAvatar';
import './ChatSettings.scss';

import { ChatIconsAdmin } from '../ChatIcons/ChatIconsAdmin';
import { ChatParticipantResponse } from '@mnspro-cloud/services/lib/mnspro-cloud/api/v2';

interface ChatSettingsParticipantTeacherProps {
  teacher: ChatParticipantResponse;
  onDeleteClick?: (userId: string) => void;
  isOwner?: boolean;
}

export const ChatSettingsParticipantTeacher: React.FC<ChatSettingsParticipantTeacherProps> = ({
  teacher,
  onDeleteClick,
  isOwner,
}) => {
  const { t } = useTranslation();

  return (
    <div className="TeacherListItem flex flex-row gap-1 items-center">
      <ChatAvatar
        variant="direct"
        ward={{
          id: teacher.userId ?? '',
          displayName: teacher.displayName ?? '',
        }}
      />
      {isOwner && <ChatIconsAdmin />}
      <Text className="flex-1">{teacher.displayName}</Text>
      {onDeleteClick && (
        <Button
          icon={<Delete24Regular />}
          appearance="transparent"
          className="primaryBtn"
          onClick={() => onDeleteClick && onDeleteClick(teacher.userId)}
          aria-label={t('pc:chat:settings:remove_participant_aria', {
            defaultValue: '{{name}} aus dem Chat entfernen',
            name: teacher.displayName,
          })}
        />
      )}
    </div>
  );
};
